import { useRef, useMemo, useEffect } from 'react';
import { useFrame } from '@react-three/fiber';
import * as THREE from 'three';

export function WizardHat() {
  return (
    <group position={[0, 0.6, 0]}>
      <mesh castShadow>
        <cylinderGeometry args={[0.8, 0.8, 0.1, 16]} />
        <meshStandardMaterial color="#220088" />
      </mesh>
      <mesh position={[0, 0.6, 0]} castShadow>
        <coneGeometry args={[0.5, 1.2, 16]} />
        <meshStandardMaterial color="#3311aa" />
      </mesh>
    </group>
  );
}

export function RocketJetpack() {
  const fire = useRef<THREE.Points>(null);

  const fireGeo = useMemo(() => {
    const geo = new THREE.BufferGeometry();
    const pos = new Float32Array(30);
    for (let i = 0; i < 30; i++) pos[i] = (Math.random() - 0.5) * 0.8;
    geo.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    return geo;
  }, []);

  useEffect(() => {
    return () => { fireGeo.dispose(); };
  }, [fireGeo]);

  useFrame(() => {
    if (fire.current) {
      const positions = fire.current.geometry.attributes.position.array as Float32Array;
      for (let i = 0; i < 30; i += 3) {
        positions[i + 1] -= 0.1;
        if (positions[i + 1] < -0.8) {
          positions[i + 1] = 0;
          positions[i] = (Math.random() - 0.5) * 0.8;
          positions[i + 2] = (Math.random() - 0.5) * 0.2;
        }
      }
      fire.current.geometry.attributes.position.needsUpdate = true;
    }
  });

  return (
    <group position={[0, 0.2, -0.6]}>
      <mesh castShadow>
        <boxGeometry args={[0.6, 0.8, 0.4]} />
        <meshStandardMaterial color="#cccccc" metalness={0.8} roughness={0.2} />
      </mesh>
      <mesh position={[-0.35, 0, 0]} castShadow>
        <cylinderGeometry args={[0.15, 0.15, 0.9, 8]} />
        <meshStandardMaterial color="#cccccc" metalness={0.8} roughness={0.2} />
      </mesh>
      <mesh position={[0.35, 0, 0]} castShadow>
        <cylinderGeometry args={[0.15, 0.15, 0.9, 8]} />
        <meshStandardMaterial color="#cccccc" metalness={0.8} roughness={0.2} />
      </mesh>
      <mesh position={[-0.35, -0.5, 0]} rotation={[Math.PI, 0, 0]}>
        <coneGeometry args={[0.1, 0.2, 8]} />
        <meshStandardMaterial color="#ff2200" />
      </mesh>
      <mesh position={[0.35, -0.5, 0]} rotation={[Math.PI, 0, 0]}>
        <coneGeometry args={[0.1, 0.2, 8]} />
        <meshStandardMaterial color="#ff2200" />
      </mesh>
      <points ref={fire} position={[0, -0.6, 0]}>
        <bufferGeometry attach="geometry" {...fireGeo} />
        <pointsMaterial color="#ff5500" size={0.2} blending={THREE.AdditiveBlending} transparent />
      </points>
    </group>
  );
}

export function CoolGlasses() {
  return (
    <group position={[0, 0.2, 0.52]}>
      <mesh position={[-0.2, 0, 0]}>
        <boxGeometry args={[0.3, 0.2, 0.05]} />
        <meshStandardMaterial color="#111111" roughness={0.1} />
      </mesh>
      <mesh position={[0.2, 0, 0]}>
        <boxGeometry args={[0.3, 0.2, 0.05]} />
        <meshStandardMaterial color="#111111" roughness={0.1} />
      </mesh>
      <mesh position={[0, 0, 0]}>
        <boxGeometry args={[0.1, 0.05, 0.05]} />
        <meshStandardMaterial color="#111111" roughness={0.1} />
      </mesh>
    </group>
  );
}
